import "./common.css";
import "./pages/dashboard/dashboard.css";
import "./pages/login/login.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Loading from "./components/Loading";
import Loader from "./components/Loader";
import SimpleSnackbar from "./components/Snackback";
import Attendants from "./pages/attendants/Attendants";
import Receipt from "./pages/ReceiptPrinting";

function App() {
  const Register = lazy(() => import("./pages/register/Register"));
  const Expenses = lazy(() => import("./pages/expenses/Expenses"));
  const Tutorials = lazy(() => import("./pages/tutorials/Tutorials"));
  const Items = lazy(() => import("./pages/products/Items"));
  const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));
  const Sales = lazy(() => import("./pages/sales/Sales"));
  const Login = lazy(() => import("./pages/login/Login"));
  const Report = lazy(() => import("./pages/reports/Report"));
  const ProductDetails = lazy(() =>
    import("./pages/productDetails/ProductDetails")
  );
  const ReceiptsList = lazy(() => import("./pages/receipts/ReceiptsList"));
  const ImportPage = lazy(() => import("./pages/import_data/ImportPage"));
  const Highlights = lazy(() => import("./pages/highlights/Highlights"));
  const HighlightDetails = lazy(() =>
    import("./pages/highlights/HighlightDetails")
  );
  const Customers = lazy(() => import("./pages/customers/Customers"));
  const Credit = lazy(() => import("./pages/credit/Credit"));
  const Invoice = lazy(() => import("./pages/invoice/Invoice"));
  const store = useSelector((state) => state.store.Store);
  const items = useSelector((state) => state.items.Items);
  const sales = useSelector((state) => state.sales.Sales);

  return (
    <BrowserRouter>
      <div className="">
        <Loading />
        <SimpleSnackbar />
        <Routes>
          <Route
            path="/tuts"
            element={
              <Suspense fallback={<Loader />}>
                <Tutorials />
              </Suspense>
            }
          />
          <Route
            path="/upload_data"
            element={
              <Suspense fallback={<Loader />}>
                <ImportPage />
              </Suspense>
            }
          />
          <Route
            path="/attendants"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Attendants />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/report"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Report />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/register"
            element={
              <Suspense fallback={<Loader />}>
                <Register />
              </Suspense>
            }
          />
          <Route
            path="/receipt"
            element={
              <Suspense fallback={<Loader />}>
                <Receipt />
              </Suspense>
            }
          />
          <Route
            path="/customers"
            element={
              <Suspense fallback={<Loader />}>
                <Customers />
              </Suspense>
            }
          />
          <Route
            path="/invoices"
            element={
              <Suspense fallback={<Loader />}>
                <Invoice />
              </Suspense>
            }
          />
          <Route
            path="/login"
            element={
              store && items !== null && sales !== null ? (
                <Navigate to="/" />
              ) : (
                <Suspense fallback={<Loader />}>
                  <Login />
                </Suspense>
              )
            }
          />
          <Route
            path="/"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Dashboard />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/expenses"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Expenses />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/credit"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Credit />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/highlights"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Highlights />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/highlights/details"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <HighlightDetails />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/receipts"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <ReceiptsList />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/sales"
            element={
              store && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <Sales />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/items"
            element={
              store && items !== null ? (
                <Suspense fallback={<Loader />}>
                  <Items />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/items/:id"
            element={
              store && items !== null && sales !== null ? (
                <Suspense fallback={<Loader />}>
                  <ProductDetails />
                </Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
